<template>
  <div class="app-activation-auto-top-up-wrapper">
    <div class="text"><slot name="txtBeforeAutoTopUp"></slot></div>
      <b-form-radio-group  required
                           class="top-up-group"
                           v-model="splittedTopUp"
                          >
        <auto-top-up
          :top-up="topUp_"
          :trigger.sync="topUp_.trigger"
          :amount.sync="topUp_.amount"
          :monthly-value="monthlyValue"
          :inside-activation="true"
        >
          <template #txtHeaderMonthly><slot name="txtHeaderMonthlyAutoTopUp"></slot></template>
          <template #lblMonthly><slot name="lblMonthlyAutoTopUp"></slot></template>
          <template #lblMonthlyAmount><slot name="lblMonthlyAmountAutoTopUp"></slot></template>
          <template #txtHeaderByLimit><slot name="txtHeaderByLimitAutoTopUp"></slot></template>
          <template #lblByLimitFirst><slot name="lblByLimitAutoTopUpFirst"></slot></template>
          <template #lblByLimitSecond><slot name="lblByLimitAutoTopUpSecond"></slot></template>
        </auto-top-up>
        <b-col cols="12">
          <b-form-radio  name="withoutAuto" :value="{'type': 'withoutAuto'}">
            <div class="text"><slot name="lblWithoutAuto">Weiter ohne automatische Aufladung</slot></div>
          </b-form-radio>
        </b-col>
      </b-form-radio-group>
  </div>
</template>

<script>
import AutoTopUp from '../../../generic/TopUp/AutoTopUp.vue'
import syncProperty from '../../../../../mixins/syncProperty'
export default {
  name: 'ActivationAutoTopUpWrapper',
  mixins: [
    syncProperty('topUp', 'topUp_')
  ],
  computed: {
    splittedTopUp: {
      get: function () {
        if (this.topUp_.type === 'monthly') {
          if (this.topUp_.trigger === null) {
            return {
              type: this.topUp_.type,
              trigger: this.monthlyValue[0]
            }
          }
          return {
            type: this.topUp_.type,
            trigger: this.topUp_.trigger
          }
        }
        return {
          type: this.topUp_.type
        }
      },
      set: function (value) {
        this.topUp_.type = value.type
        if (value.type === 'withoutAuto') {
          this.topUp_.trigger = null
          this.topUp_.amount = null
        }
        if (value.type === 'monthly') {
          this.topUp_.trigger = value.trigger
        }
      }
    }
  },
  components: { AutoTopUp },
  props:
    [
      'monthlyValue'
    ]
}
</script>
